export const endowments = [
    /* ******************** ALL SPORTS ******************** */
    {
        sport: "all",
        dataRef: "drBarbaraHibnerMemFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTeO0lNh0a0sWAlyh4KC0JoqXd-8A-OdXMbxZ1HMxCUtpknwbyWycONGsPhs8gApYlt7G0sVF5HIDsc/pub?gid=1370398951&single=true&output=csv",
        domEl: document.querySelector("#dr-barbara-hibner-memorial-fund"),
    },
    {
        sport: "all",
        dataRef: "clarenceGoodwinMemFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTeO0lNh0a0sWAlyh4KC0JoqXd-8A-OdXMbxZ1HMxCUtpknwbyWycONGsPhs8gApYlt7G0sVF5HIDsc/pub?gid=1773416950&single=true&output=csv",
        domEl: document.querySelector("#clarence-c-goodwin-memorial-fund"),
    },
    {
        sport: "all",
        dataRef: "griessFamilyFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTeO0lNh0a0sWAlyh4KC0JoqXd-8A-OdXMbxZ1HMxCUtpknwbyWycONGsPhs8gApYlt7G0sVF5HIDsc/pub?gid=1106610085&single=true&output=csv",
        domEl: document.querySelector("#bret-brenda-griess-family"),
    },
    {
        sport: "all",
        dataRef: "carlsonFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTeO0lNh0a0sWAlyh4KC0JoqXd-8A-OdXMbxZ1HMxCUtpknwbyWycONGsPhs8gApYlt7G0sVF5HIDsc/pub?gid=1793797096&single=true&output=csv",
        domEl: document.querySelector("#conrad-detta-rohn-carlson-fund"),
    },
    {
        sport: "all",
        dataRef: "barnardScholarshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTeO0lNh0a0sWAlyh4KC0JoqXd-8A-OdXMbxZ1HMxCUtpknwbyWycONGsPhs8gApYlt7G0sVF5HIDsc/pub?gid=301266240&single=true&output=csv",
        domEl: document.querySelector("#janet-and-bryan-barnard-scholarship-fund"),
    },
    /* ******************** BASEBALL ******************** */
    {
        sport: "baseball",
        dataRef: "alexPlucknettScholarshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQdpuEltjqJitDEV6E9gkmA1NmjQrSZT5RwCzVY27wRSHGMnqUOHKu7xtRQkH6sZgdn_-b57Y2wFplU/pub?gid=1370398951&single=true&output=csv",
        domEl: document.querySelector("#alex-plucknett-scholarship-fund"),
    },
    {
        sport: "baseball",
        dataRef: "delKopfBaseballScholarshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQdpuEltjqJitDEV6E9gkmA1NmjQrSZT5RwCzVY27wRSHGMnqUOHKu7xtRQkH6sZgdn_-b57Y2wFplU/pub?gid=1773416950&single=true&output=csv",
        domEl: document.querySelector("#del-kopf-baseball-scholarship-sub-fund"),
    },
    {
        sport: "baseball",
        dataRef: "hrdlickaScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQdpuEltjqJitDEV6E9gkmA1NmjQrSZT5RwCzVY27wRSHGMnqUOHKu7xtRQkH6sZgdn_-b57Y2wFplU/pub?gid=1793797096&single=true&output=csv",
        domEl: document.querySelector("#florian-and-linda-hrdlicka-scholarship"),
    },
    {
        sport: "baseball",
        dataRef: "huskerBaseballScholarshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQdpuEltjqJitDEV6E9gkmA1NmjQrSZT5RwCzVY27wRSHGMnqUOHKu7xtRQkH6sZgdn_-b57Y2wFplU/pub?gid=1106610085&single=true&output=csv",
        domEl: document.querySelector("#dianne-sizemore-husker-baseball-scholarship-fund"),
    },
    {
        sport: "baseball",
        dataRef: "dickBecherBaseballScholarshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQdpuEltjqJitDEV6E9gkmA1NmjQrSZT5RwCzVY27wRSHGMnqUOHKu7xtRQkH6sZgdn_-b57Y2wFplU/pub?gid=301266240&single=true&output=csv",
        domEl: document.querySelector("#dick-becher-baseball-scholarship-fund"),
    },
    {
        sport: "baseball",
        dataRef: "johnsonFamilyBaseballScholarshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQdpuEltjqJitDEV6E9gkmA1NmjQrSZT5RwCzVY27wRSHGMnqUOHKu7xtRQkH6sZgdn_-b57Y2wFplU/pub?gid=1536528628&single=true&output=csv",
        domEl: document.querySelector("#richard-johnson-scholarship-fund"),
    },
    /* ******************** BASKETBALL ******************** */
    {
        sport: "basketball",
        dataRef: "busWhiteheadMemScholarshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vS2FJnrBkb9cJBLunlGfqesyWDjXpbVLMFHeumculq2naO8UaYgXL1CygJGgfikcFZZdQK4mNR5f_FA/pub?gid=1370398951&single=true&output=csv",
        domEl: document.querySelector("#bus-whitehead-memorial-scholarship-fund"),
    },
    {
        sport: "basketball",
        dataRef: "dTorenAthleticFellowshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vS2FJnrBkb9cJBLunlGfqesyWDjXpbVLMFHeumculq2naO8UaYgXL1CygJGgfikcFZZdQK4mNR5f_FA/pub?gid=1473523723&single=true&output=csv",
        domEl: document.querySelector("#david-g-toren-athletic-fellowship-fund"),
    },
    {
        sport: "basketball",
        dataRef: "hosmanFamilyScholarshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vS2FJnrBkb9cJBLunlGfqesyWDjXpbVLMFHeumculq2naO8UaYgXL1CygJGgfikcFZZdQK4mNR5f_FA/pub?gid=798786410&single=true&output=csv",
        domEl: document.querySelector("#hosman-family-scholarship-fund"),
    },
    {
        sport: "basketball",
        dataRef: "latimerFamilyWbbScholarshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vS2FJnrBkb9cJBLunlGfqesyWDjXpbVLMFHeumculq2naO8UaYgXL1CygJGgfikcFZZdQK4mNR5f_FA/pub?gid=1325875704&single=true&output=csv",
        domEl: document.querySelector("#latimer-family-womens-basketball-fund"),
    },
    {
        sport: "basketball",
        dataRef: "lCrossCoachesScholarshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vS2FJnrBkb9cJBLunlGfqesyWDjXpbVLMFHeumculq2naO8UaYgXL1CygJGgfikcFZZdQK4mNR5f_FA/pub?gid=191749823&single=true&output=csv",
        domEl: document.querySelector("#lorraine-cross-coaches-fund"),
    },
    /* ******************** FOOTBALL ******************** */
    {
        sport: "football",
        dataRef: "aEvelandMemScholarshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRGTI71OisfviwtvhQOWi0hgvDK-isnKYXhsY_BV2NoUeZ4dHMjndcKl77swha6mfq2qHziGvf_Q8OW/pub?gid=1370398951&single=true&output=csv",
        domEl: document.querySelector("#alan-eveland-memorial-scholarship"),
    },
    {
        sport: "football",
        dataRef: "bBerringerMemScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRGTI71OisfviwtvhQOWi0hgvDK-isnKYXhsY_BV2NoUeZ4dHMjndcKl77swha6mfq2qHziGvf_Q8OW/pub?gid=1473523723&single=true&output=csv",
        domEl: document.querySelector("#brook-berringer-memorial-scholarship"),
    },
    {
        sport: "football",
        dataRef: "burnellStudentManagerScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRGTI71OisfviwtvhQOWi0hgvDK-isnKYXhsY_BV2NoUeZ4dHMjndcKl77swha6mfq2qHziGvf_Q8OW/pub?gid=798786410&single=true&output=csv",
        domEl: document.querySelector("#burnell-student-manager-scholarship"),
    },
    {
        sport: "football",
        dataRef: "cFischerScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRGTI71OisfviwtvhQOWi0hgvDK-isnKYXhsY_BV2NoUeZ4dHMjndcKl77swha6mfq2qHziGvf_Q8OW/pub?gid=1325875704&single=true&output=csv",
        domEl: document.querySelector("#cletus-fischer-scholarship"),
    },
    {
        sport: "football",
        dataRef: "dNobleMemScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRGTI71OisfviwtvhQOWi0hgvDK-isnKYXhsY_BV2NoUeZ4dHMjndcKl77swha6mfq2qHziGvf_Q8OW/pub?gid=191749823&single=true&output=csv",
        domEl: document.querySelector("#dave-noble-memorial-scholarship"),
    },
    {
        sport: "football",
        dataRef: "dStannardScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRGTI71OisfviwtvhQOWi0hgvDK-isnKYXhsY_BV2NoUeZ4dHMjndcKl77swha6mfq2qHziGvf_Q8OW/pub?gid=1833331071&single=true&output=csv",
        domEl: document.querySelector("#david-l-stannard-scholarship"),
    },
    {
        sport: "football",
        dataRef: "eBeacomScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRGTI71OisfviwtvhQOWi0hgvDK-isnKYXhsY_BV2NoUeZ4dHMjndcKl77swha6mfq2qHziGvf_Q8OW/pub?gid=455317954&single=true&output=csv",
        domEl: document.querySelector("#elizabeth-abel-beacom-scholarship"),
    },
    {
        sport: "football",
        dataRef: "fSolichPostGradStudentScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRGTI71OisfviwtvhQOWi0hgvDK-isnKYXhsY_BV2NoUeZ4dHMjndcKl77swha6mfq2qHziGvf_Q8OW/pub?gid=706562478&single=true&output=csv",
        domEl: document.querySelector("#frank-solich-post-graduate-student-scholarship"),
    },
    {
        sport: "football",
        dataRef: "gSullivanEndowedScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRGTI71OisfviwtvhQOWi0hgvDK-isnKYXhsY_BV2NoUeZ4dHMjndcKl77swha6mfq2qHziGvf_Q8OW/pub?gid=977163055&single=true&output=csv",
        domEl: document.querySelector("#george-finley-sullivan-endowed-scholarship"),
    },
    {
        sport: "football",
        dataRef: "jYoungMemFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRGTI71OisfviwtvhQOWi0hgvDK-isnKYXhsY_BV2NoUeZ4dHMjndcKl77swha6mfq2qHziGvf_Q8OW/pub?gid=322532751&single=true&output=csv",
        domEl: document.querySelector("#jake-young-memorial-fund"),
    },
    {
        sport: "football",
        dataRef: "beckEndowedScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRGTI71OisfviwtvhQOWi0hgvDK-isnKYXhsY_BV2NoUeZ4dHMjndcKl77swha6mfq2qHziGvf_Q8OW/pub?gid=790539735&single=true&output=csv",
        domEl: document.querySelector("#janice-and-rodney-beck-endowed-scholarship"),
    },
    {
        sport: "football",
        dataRef: "sFoltzScholarshipAward",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRGTI71OisfviwtvhQOWi0hgvDK-isnKYXhsY_BV2NoUeZ4dHMjndcKl77swha6mfq2qHziGvf_Q8OW/pub?gid=1140178245&single=true&output=csv",
        domEl: document.querySelector("#sam-foltz-scholarship-award"),
    },
    /* ******************** GOLF ******************** */
    {
        sport: "golf",
        dataRef: "bRohmanMemGolfScholarshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQ48VVPV2GXsjBUYNQ6xoKVKhXq0LMRvfivcU22WLnDMncI7hYNTeYZkyDwLlKwlEZh-dcH27qWymbu/pub?gid=1370398951&single=true&output=csv",
        domEl: document.querySelector("#beatrice-dierks-rohman-memorial-golf-scholarship-award"),
    },
    {
        sport: "golf",
        dataRef: "dSpanglerGolfScholarshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQ48VVPV2GXsjBUYNQ6xoKVKhXq0LMRvfivcU22WLnDMncI7hYNTeYZkyDwLlKwlEZh-dcH27qWymbu/pub?gid=898504840&single=true&output=csv",
        domEl: document.querySelector("#dick-spangler-golf-scholarship-fund"),
    },
    {
        sport: "golf",
        dataRef: "jDobsonMemScholarshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQ48VVPV2GXsjBUYNQ6xoKVKhXq0LMRvfivcU22WLnDMncI7hYNTeYZkyDwLlKwlEZh-dcH27qWymbu/pub?gid=795536715&single=true&output=csv",
        domEl: document.querySelector("#jane-bell-dobson-memorial-scholarship-fund"),
    },
    {
        sport: "golf",
        dataRef: "tSchmidtScholarshipFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQ48VVPV2GXsjBUYNQ6xoKVKhXq0LMRvfivcU22WLnDMncI7hYNTeYZkyDwLlKwlEZh-dcH27qWymbu/pub?gid=1964473717&single=true&output=csv",
        domEl: document.querySelector("#tom-schmidt-scholarship-fund"),
    },
    /* ******************** GYMNASTICS ******************** */
    {
        sport: "gymnastics",
        dataRef: "toddMensGymnasticsScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTl6uPaVrfYYGvb0PlGQZ0UT90r7WqEwwZGa9Y5c6OjJ3jHmd7ldNPlNZEZr1nC2FG-mjIWSeXpMLk1/pub?gid=1370398951&single=true&output=csv",
        domEl: document.querySelector("#steve-and-lisa-todd-mens-gymnastics-scholarship"),
    },
    /* ******************** SOCCER ******************** */
    {
        sport: "soccer",
        dataRef: "priceSoccerScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQHLc7W0GEuX0K2KfwqY0lf5B__trUEO10koGiIfqOVw3fAFvs9nxBwMeXjDR6OQX8v0o0ibT3U4ghk/pub?gid=1370398951&single=true&output=csv",
        domEl: document.querySelector("#tom-and-pam-price-soccer-scholarship"),
    },
    /* ******************** SOFTBALL ******************** */
    {
        sport: "softball",
        dataRef: "jGeisMemScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRIOzbHbjBtqZ3DJeM6PbBMeV-VE0GhB9bEEzS3TsiWtRcW4X-5Kd915AVkECDmNpP7qH22uZrC58Pw/pub?gid=1370398951&single=true&output=csv",
        domEl: document.querySelector("#julie-geis-memorial-scholarship"),
    },
    {
        sport: "softball",
        dataRef: "rRaimondiMemScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vRIOzbHbjBtqZ3DJeM6PbBMeV-VE0GhB9bEEzS3TsiWtRcW4X-5Kd915AVkECDmNpP7qH22uZrC58Pw/pub?gid=282954678&single=true&output=csv",
        domEl: document.querySelector("#richard-raimondi-memorial-scholarship"),
    },
    /* ******************** SWIMMING & DIVING ******************** */
    {
        sport: "swim-dive",
        dataRef: "perryMemAthleticScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQcIP7im926xhv0WvygBiqG6V9AhmjDaITw6O8iUy6yK6k_MCqLRSInWzwwXM4mGGNzPQUfMIEXBsVp/pub?gid=1370398951&single=true&output=csv",
        domEl: document.querySelector("#samuel-h-perry-memorial-athletic-scholarship"),
    },
    /* ******************** TENNIS ******************** */
    {
        sport: "tennis",
        dataRef: "orloffFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vSheGeotUfD-8urrQnRUjurhNjgV_NwsKlk8Pf-BYiU9cB4uasBNsw3MBT_EfROjYJFpkbI_4gcKq15/pub?gid=1370398951&single=true&output=csv",
        domEl: document.querySelector("#louis-and-charlotte-orloff-fund"),
    },
    /* ******************** TRACK & FIELD ******************** */
    {
        sport: "track-field",
        dataRef: "eWeirMemScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTZt7gu1_jH4xW9ixeMttifvI27ATMj8z29gnAH33mwTYuK9cKWUWDDjaibRaISrwCXk0wHYh0xLUok/pub?gid=1370398951&single=true&output=csv",
        domEl: document.querySelector("#ed-weir-memorial-scholarship"),
    },
    /* ******************** VOLLEYBALL ******************** */
    {
        sport: "volleyball",
        dataRef: "breithauptFamilyScholarship",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQ1dCSOF3dVNfCcimp6QT3AAO_J-eciYPufdBwE2xWtZdxgkNxvD9B9DSJ1dOHTJLK81-K7otAPRKZp/pub?gid=1370398951&single=true&output=csv",
        domEl: document.querySelector("#breithaupt-family"),
    },
    {
        sport: "volleyball",
        dataRef: "latimerFamilyVbFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQ1dCSOF3dVNfCcimp6QT3AAO_J-eciYPufdBwE2xWtZdxgkNxvD9B9DSJ1dOHTJLK81-K7otAPRKZp/pub?gid=984445145&single=true&output=csv",
        domEl: document.querySelector("#latimer-family-volleyball-fund"),
    },
    {
        sport: "volleyball",
        dataRef: "matchClubChampsFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQ1dCSOF3dVNfCcimp6QT3AAO_J-eciYPufdBwE2xWtZdxgkNxvD9B9DSJ1dOHTJLK81-K7otAPRKZp/pub?gid=83278514&single=true&output=csv",
        domEl: document.querySelector("#match-club-fund"),
    },
    {
        sport: "volleyball",
        dataRef: "rSchwartzFund",
        data: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQ1dCSOF3dVNfCcimp6QT3AAO_J-eciYPufdBwE2xWtZdxgkNxvD9B9DSJ1dOHTJLK81-K7otAPRKZp/pub?gid=1977135096&single=true&output=csv",
        domEl: document.querySelector("#rachel-schwartz-fund"),
    },
];
